import React, { Component } from "react";
import { connect } from "react-redux";
import {
	Alert,
	Button,
	Form,
	FormControl,
	FormGroup,
	FormLabel,
} from "react-bootstrap";
import Spinner from "react-spinner";
import "react-spinner/react-spinner.css";
import { push } from "connected-react-router";
import { updateShift, viewShift, settingsPage } from "../../actions";
import { isShiftsFeatureEnabled } from "../../utils/shiftsFeature";
import DeleteShiftOverlay from "../Overlays/DeleteShiftOverlay";

function isoToDatetimeLocal(iso) {
		if (!iso) {
				return "";
		}
		const d = new Date(iso);
		if (Number.isNaN(d.getTime())) {
				return "";
		}
		const pad = (n) => String(n).padStart(2, "0");
		return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

class EditShift extends Component {
	constructor(props) {
		super(props);
		this.state = {
			errors: {
				shiftName: false,
				startTime: false,
				endTime: false,
			},
			submitting: false,
		};
	}

	componentDidMount() {
		if (!this.props.settingsData) {
			this.props.settingsPage(this.props.tvClient);
		} else if (isShiftsFeatureEnabled(this.props.settingsData)) {
			this.props.viewShift(
				this.props.tvClient,
				this.props.match.params.documentId,
			);
		}
	}

	componentDidUpdate(prevProps) {
		if (!this.props.settingsData) {
			return;
		}
		if (!isShiftsFeatureEnabled(this.props.settingsData)) {
			if (
				!prevProps.settingsData ||
				isShiftsFeatureEnabled(prevProps.settingsData)
			) {
				this.props.push("/settings");
			}
			return;
		}
		if (
			!prevProps.settingsData &&
			this.props.match.params.documentId
		) {
			this.props.viewShift(
				this.props.tvClient,
				this.props.match.params.documentId,
			);
		}
	}

	submitShift(e) {
		e.preventDefault();
		const id = this.props.match.params.documentId;
		const name = this.shiftName.value.trim();
		const startVal = this.startTime.value;
		const endVal = this.endTime.value;
		const tz = (this.localTimezone.value || "UTC").trim();
		const loc = this.locationId.value;

		if (!name) {
			this.setState({
				errors: {
					shiftName: true,
					startTime: false,
					endTime: false,
				},
			});
			return;
		}
		if (!startVal) {
			this.setState({
				errors: {
					shiftName: false,
					startTime: true,
					endTime: false,
				},
			});
			return;
		}
		if (!endVal) {
			this.setState({
				errors: {
					shiftName: false,
					startTime: false,
					endTime: true,
				},
			});
			return;
		}

		this.setState({
			errors: {
				shiftName: false,
				startTime: false,
				endTime: false,
			},
		});

		const startTime = new Date(startVal).toISOString();
		const endTime = new Date(endVal).toISOString();
		const locationId = loc === "" ? null : loc;

		this.setState({ submitting: true });
		this.props
				.updateShift(
						this.props.tvClient,
						id,
						name,
						startTime,
						endTime,
						tz,
						locationId,
				)
				.finally(() => {
						this.setState({ submitting: false });
				});
	}

	render() {
		if (!this.props.settingsData || !isShiftsFeatureEnabled(this.props.settingsData)) {
			return (
				<div>
					<h1 className="page-header">Edit Shift</h1>
					<p>Loading…</p>
				</div>
			);
		}

		let locations = [];
		if (this.props.settingsData && this.props.settingsData.locations) {
				locations = this.props.settingsData.locations;
				if (!Array.isArray(locations)) {
						locations = Object.values(locations);
				}
		}
		const s = this.props.shiftData;

		return (
				<div>
						<h1 className="page-header">
								Edit Shift
								<small>
										Update shift details
										<span className="backLink">
												{" "}
												|{" "}
												<button
														type="button"
														className="simulateAnchor"
														onClick={() => window.history.back()}
												>
														Go Back
												</button>{" "}
												|{" "}
												<DeleteShiftOverlay
														shiftId={this.props.match.params.documentId}
												/>
										</span>
								</small>
						</h1>

						{this.props.viewingShift && <Spinner />}

						{this.props.viewShiftError && (
								<Alert variant="danger">
										{this.props.viewShiftError.message}
								</Alert>
						)}

						{s && (
								<Form onSubmit={this.submitShift.bind(this)} className="new-case-form">
										<FormGroup controlId="shiftName">
												<FormLabel>Name *</FormLabel>
												<FormControl
														type="text"
														defaultValue={s.name}
														ref={(ref) => {
																this.shiftName = ref;
														}}
												/>
												{this.state.errors.shiftName && (
														<Alert variant="danger">Name is required.</Alert>
												)}
										</FormGroup>

										<FormGroup controlId="startTime">
												<FormLabel>Start (local) *</FormLabel>
												<FormControl
														type="datetime-local"
														defaultValue={isoToDatetimeLocal(s.start_time)}
														ref={(ref) => {
																this.startTime = ref;
														}}
												/>
												{this.state.errors.startTime && (
														<Alert variant="danger">Start time is required.</Alert>
												)}
										</FormGroup>

										<FormGroup controlId="endTime">
												<FormLabel>End (local) *</FormLabel>
												<FormControl
														type="datetime-local"
														defaultValue={isoToDatetimeLocal(s.end_time)}
														ref={(ref) => {
																this.endTime = ref;
														}}
												/>
												{this.state.errors.endTime && (
														<Alert variant="danger">End time is required.</Alert>
												)}
										</FormGroup>

										<FormGroup controlId="localTimezone">
												<FormLabel>IANA timezone</FormLabel>
												<FormControl
														type="text"
														defaultValue={s.local_timezone || "UTC"}
														ref={(ref) => {
																this.localTimezone = ref;
														}}
												/>
										</FormGroup>

										<FormGroup controlId="locationId">
												<FormLabel>Location (optional)</FormLabel>
												<FormControl
														as="select"
														defaultValue={
																s.location_id === null || s.location_id === undefined
																		? ""
																		: String(s.location_id)
														}
														ref={(ref) => {
																this.locationId = ref;
														}}
												>
														<option value="">All locations</option>
														{locations.map((d) => (
																<option value={d.location_id} key={d.location_id}>
																		{d.name}
																</option>
														))}
												</FormControl>
										</FormGroup>

										<FormGroup className="submit-buttons">
												<Button
														type="submit"
														className="float-right"
														disabled={this.state.submitting}
												>
														Update
												</Button>
										</FormGroup>
								</Form>
						)}
				</div>
		);
	}
}

const mapStateToProps = (state) => ({
		tvClient: state.login.tvClient,
		settingsData: state.settingsPage.settingsData,
		viewingShift: state.viewShift.viewingShift,
		viewShiftError: state.viewShift.viewShiftError,
		shiftData: state.viewShift.shiftData,
});

export default connect(mapStateToProps, {
		viewShift,
		updateShift,
		settingsPage,
		push,
})(EditShift);
